import { regexes } from "@swa-ui/form";
import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const REDRESS_NUMBER_SCHEMA_FIELD_NAME = "redressNumber";

export const getRedressNumberFormFieldSchema = () =>
  yup
    .string()
    .when({
      is: (exists) => !!exists,
      then: yup.string().min(7),
    })
    .max(13)
    .matches(regexes.alphaNumeric)
    .label(i18n("RedressNumberFormField__LABEL").toLowerCase());
